module.exports = __webpack_public_path__ + "static/lightning-754d78bfe2205a3ca14bfce4bfb932b0.mp4";